import {createFileRoute} from "@tanstack/react-router";
import {ErrorComponent} from "./-errorComponent";
import {NotFoundComponent} from "./-notFoundComponent";
import {PendingComponent} from "./-pendingComponent";
import {RouteComponent} from "./-routeComponent";
import {adgptChatsQueryOptions} from "~/utilities/queries";

export const Route = createFileRoute("/_withAuthenticationStatus/_authenticated/_withProfileStatus/_profileCompleted/w/$workspaceId/_adgptScaffold")({
    loader: async ({context}) => {
        const intellsysBaseUrl = context.intellsysBaseUrl;
        const accessToken = context.authenticationStatus.accessToken;
        const workspaceId = context.workspace.id;

        // Pre-fetching all chats before the component mounts,
        // the useQuery inside the sidebar will take over this cache key once the component mounts.
        // This is an one time pre-fetching for this queryKey. Both this prefetch and the sidebar's
        // useQuery share `adgptChatsQueryOptions` so their fetch + zod schema can't drift apart.
        await context.queryClient.ensureQueryData(adgptChatsQueryOptions({intellsysBaseUrl, accessToken, workspaceId}));

        return {
            accessibleWorkspaces: context.accessibleWorkspaces,
            workspace: context.workspace,
            accessToken,
            intellsysBaseUrl,
            pricingPlanNudgeStatus: context.pricingPlanNudgeStatus,
            subscriptionDetails: context.subscriptionDetails,
        };
    },
    component: RouteComponent,
    errorComponent: ErrorComponent,
    pendingComponent: PendingComponent,
    notFoundComponent: NotFoundComponent,
});
